import axios from 'axios';

export class AvailableLendService {
    /**
     * Función que consulta el back para obtener la información
     * que se muesta en la pantalla "Disponible a prestar".
     * @param emisoraStr String con el cual se busca
     *                   Si viene vacío trae todos los datos
     * @returns {Promise<unknown>} Lista con la información a mostrar.
     */
    getDataAvailableLend(emisoraStr) {
        return axios.get('/appapv/getAvailableLendClient.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: emisoraStr,
            }
        }).then(res => res.data.payload);
    }
}